var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerCentricityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0273 23.3313C27.8588 22.6595 28.5803 21.9125 29.4231 21.4278C31.8166 20.0504 34.2326 20.1709 36.4587 21.8572C38.6758 23.536 39.6309 25.9957 39.4028 28.974C39.2691 30.7255 38.6106 32.2536 37.4992 33.5042C34.7855 36.5591 32.0649 39.6064 29.3287 42.6362C28.0353 44.0688 26.1856 44.0513 24.8889 42.6123C22.1874 39.6127 19.4759 36.6244 16.8172 33.5783C14.8293 31.3006 14.263 28.5559 15.2192 25.565C16.1665 22.603 18.1533 20.9268 20.9491 20.5803C23.0549 20.3191 24.9023 21.08 26.4564 22.6972C26.6598 22.9094 26.8542 23.1317 27.0531 23.3489C27.0633 23.3602 27.0779 23.3652 27.0262 23.3313H27.0273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.362 28.5905C13.1946 28.5905 13.0507 28.5905 12.9058 28.5905C10.1088 28.5905 7.31189 28.593 4.51495 28.5905C2.15065 28.588 0.621263 26.8326 0.566201 24.1921C0.504396 21.2552 1.21346 18.6386 2.93388 16.3948C3.82162 15.2359 4.89027 14.3343 6.12636 13.6839C6.25559 13.6161 6.38482 13.5471 6.559 13.4554C4.69475 11.8533 3.72273 9.79535 3.81375 7.18495C3.8823 5.21114 4.59586 3.54998 5.88589 2.20523C8.46258 -0.480509 12.5484 -0.293424 14.9745 2.59948C17.4096 5.50369 17.4141 10.5763 13.9531 13.4642C16.3724 14.6558 18.1266 16.5718 19.1761 19.294C15.3993 20.9464 13.462 24.015 13.3631 28.5917L13.362 28.5905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCentricityIcon);
export default __webpack_public_path__ + "static/media/customerCentricityIcon.317a7357fee614dea321aff32314b504.svg";
export { ForwardRef as ReactComponent };